module.exports = __webpack_public_path__ + "ea6fc4884b312b00aa76c0ad2888e4ca.svg";